import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function MultiDatabaseFieldAccordion({
  combinedExams,
  databaseField,
  fieldLabel,
  isDarkMode,
}) {
  const [expandedPanel, setExpandedPanel] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      {combinedExams.map((exam, examIndex) => {
        const studyPrefix = exam.modality && exam.study_description
          ? `${exam.modality} | ${exam.study_description}`
          : exam.study_description || `Studie ${examIndex + 1}`;
        const examFieldValue = exam[databaseField] ?? '';

        return (
          <Accordion
            key={`${databaseField}-exam-${exam.id || examIndex}`}
            expanded={expandedPanel === examIndex}
            onChange={() => setExpandedPanel(expandedPanel === examIndex ? -1 : examIndex)}
            disableGutters
            elevation={0}
            sx={{
              '&:before': { display: 'none' },
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '4px !important',
              mb: 1,
              overflow: 'hidden',
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 40, '& .MuiAccordionSummary-content': { my: 0.5 } }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: 'primary.main' }}>
                {studyPrefix}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0 }}>
              {fieldLabel && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                  {fieldLabel}
                </Typography>
              )}
              <TextField
                fullWidth
                size="small"
                value={examFieldValue}
                disabled
                multiline
                minRows={2}
                sx={{
                  '& .MuiInputBase-root': {
                    backgroundColor: 'var(--rd-db-field-bg)',
                  },
                  '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: 'var(--rd-text-primary)',
                  },
                  '& .MuiOutlinedInput-root.Mui-disabled fieldset': {
                    borderColor: 'color-mix(in srgb, var(--rd-primary) 40%, var(--rd-border))',
                  },
                }}
              />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}
